import { ReactElement } from 'react';
import { NavItemProps } from 'src/components/nav-section';
import NavItem from 'src/components/nav-section/vertical/NavItem';
import useActiveLink from 'src/hooks/useActiveLink';

type NavLinkProps = {
  title: string;
  path: string;
  icon: ReactElement;
} & Omit<NavItemProps, 'depth' | 'item'>;

export const NavLink = ({ title, path, icon, ...other }: NavLinkProps) => {
  const { active } = useActiveLink(path, false);

  return (
    <NavItem
      depth={1}
      active={active}
      item={{
        title,
        icon,
        path,
      }}
      {...other}
    />
  );
};
